let progress_bars = document.querySelectorAll('.progress-bar');
let free_shipping_trashhold_elements = document.querySelectorAll('.step__description-trashhold .trashhold');
let step_shippings = document.querySelectorAll('.progress-bar__step[data-step="shipping"]');
let step_gifts = document.querySelectorAll('.progress-bar__step[data-step="gift"]') || false;
let is_cart_page = false;
let is_product_builder_page = false;
let free_gift_exists = locales_variables.free_gift_from.length == 0 ? false : true;

if (location.href.indexOf('/cart') > -1) is_cart_page = true;
if (location.href.indexOf('/product-builder') > -1) is_product_builder_page = true;

let free_gift_trashhold_amount = parseInt(locales_variables.free_gift_from);
let free_shipping_trashhold_amount = parseInt(locales_variables.free_shipping_from);


const calculateProgressBar = async () => {
    let current_cart_subtotal = await getCart().then(data =>{
        return data.original_total_price / 100.0;
    });

    //Check Free Shipping
    if (current_cart_subtotal < free_shipping_trashhold_amount){
        free_shipping_trashhold_elements.forEach(el => el.innerHTML = `${(free_shipping_trashhold_amount - current_cart_subtotal).toFixed(2)}`);
        if (free_gift_exists){
            progress_bars.forEach(bar => bar.style.width = `${current_cart_subtotal}%`);
        }else{
            progress_bars.forEach(bar => bar.style.width = `${ ((100 * current_cart_subtotal ) / free_shipping_trashhold_amount) - 15}%`);
        }
       
    }else{
       
        //Hide trashhold message
        step_shippings.forEach(el => el.querySelector('.step__description-trashhold').classList.add('hidden'));
        //Show sucess message
        step_shippings.forEach(el => el.querySelector('.step__description-success').classList.remove('hidden'));
        //change icon color
        step_shippings.forEach(el => el.classList.add('svg__active'));
        //change progressbar width (if no free gift - fill bar with 100%)
        if (free_gift_exists){
            progress_bars.forEach(bar => bar.style.width = `25%`);
        }else{
            progress_bars.forEach(bar => bar.style.width = `100%`);
        }
        
    } 

    //include this logic only if free gift exist
    if (free_gift_exists){
        if (current_cart_subtotal > free_gift_trashhold_amount){
            //Hide trashhold message
            step_gifts && step_gifts.forEach(el => el.querySelector('.step__description-trashhold').classList.add('hidden'));
            //Show sucess message
            step_gifts && step_gifts.forEach(el => el.querySelector('.step__description-success').classList.remove('hidden'));
            //change icon color
            step_gifts && step_gifts.forEach(el => el.classList.add('svg__active'));
            //change progressbar width
            progress_bars.forEach(bar => bar.style.width = `77%`);
        }else{
            if (current_cart_subtotal > 30 && current_cart_subtotal < free_gift_trashhold_amount) {
                progress_bars.forEach(bar => bar.style.width = `${current_cart_subtotal * 0.65}%`);
            }
        }
    }
} 

const checkMovProduct = async () => {
    const cart = await getCart();
    console_log(cart.items_subtotal_price / 100)
    let giftExistInCart = false;
    let key;

    for (let item of cart.items){
        if (item.handle == locales_variables.free_gift_product.handle || locales_variables.gift_exceptions.indexOf(item.handle) > -1){
            if (item.properties.hasOwnProperty('_isMov')) {
                giftExistInCart = true;
                key = item.key;
            } 
        }
    }

    
    if (parseFloat(cart.items_subtotal_price / 100) > free_gift_trashhold_amount) {
        if (!giftExistInCart) {
            setTimeout(async () => await addGiftProduct(), 1000)
            //await addGiftProduct();
            return true;
        } 
    }else{
        if (giftExistInCart) await removeGiftProduct(key);
        return false;
    }
}

const buildFormData = () => {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    let formData = new FormData();
    formData.append('id', locales_variables.free_gift_product.variantId);
    formData.append('quantity', 1);
    formData.append('properties[_isMov]', 'true');
    formData.append('sections', document.querySelector('cart-notification').getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    return config;
}

const addGiftProduct = async () => {
    if (location.href.indexOf('/cart') > -1) {
        document.querySelector('cart-items').enableLoading();
    }
    
    let cart_link = document.getElementById('cart-notification-button') || false;

    cart_link && cart_link.classList.add('disabled');
    console_log('add gift mov')

    await fetch(`${routes.cart_add_url}`, buildFormData())
    .then(function(response) {
        return response.json();
    }).then(function(response) {
        console_log('gift mov added:', response);
        document.querySelector('cart-notification').renderContents(response);
        if (is_cart_page){
            location.reload();
        }
    }).catch(function(err) {
        console.error(err);
    })
    .finally(()=> {
        if (location.href.indexOf('/cart') > -1) {
            document.querySelector('cart-items').disableLoading();
        }
        cart_link && cart_link.classList.remove('disabled')
    });
}

const removeGiftProduct = async (key) => {
    console_log('remove gift mov')
    if (location.href.indexOf('/cart') > -1) {
        document.querySelector('cart-items').disableLoading();
    }
    
    let cart_link = document.getElementById('cart-notification-button') || false;

    cart_link && cart_link.classList.add('disabled');

    await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ 
            id: key, 
            quantity: 0
        })
    }).then(function(response) {
        return response.json();
    }).then(function(json) {
        console_log('gift mov removed:', json);
        if (is_cart_page){
            location.reload();
        }
    }).catch(function(err) {
        console_error(err);
    })
    .finally(()=> {
        cart_link && cart_link.classList.remove('disabled')
    });
}


//on product added to cart event
if(!is_cart_page) { 
    document.body.addEventListener('product-added-to-cart', () => {
        calculateProgressBar();
        //Don't add gift automatically at the Product Builder page, bcz logic there's a bit differ
        //Only if free gift exist
        if(!is_product_builder_page && free_gift_exists){
            checkMovProduct();
        } 
    });
}else{
    document.body.addEventListener("can-check-mov", async (event) => {
        if(free_gift_exists){
            await checkMovProduct();
        } 
       
        if (event.detail.properties?._swapped_with) {
            console_log('swapped with property exists at the itm added to cart from progress-bar js')
        }else {
            location.reload();
        }
        
    });

    document.body.addEventListener("cart-update", async () => {
        if(free_gift_exists){
            await checkMovProduct();
        } 

        console_log('cart-update')
    });
}